import { render, staticRenderFns } from "./StockBatchReportFilter.vue?vue&type=template&id=bce8a932&"
import script from "./StockBatchReportFilter.vue?vue&type=script&lang=ts&"
export * from "./StockBatchReportFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports